module.exports = __webpack_public_path__ + "img/hamb.0fbd36e6.svg";